export default "__VITE_ASSET__BYp0FyAt__";